import React, { lazy, Suspense } from 'react';
import { Route, Redirect } from 'react-router';

import LoginService from './services/login/LoginService';

const Home = lazy(() => import('./containers/home/HomePage'));
const StatusHomologacao = lazy(() => import('./containers/statusHomologacao/StatusHomologacao'));
const LoginFornecedor = lazy(() => import('./containers/login/LoginFornecedor'));
const IndicaFornecedor = lazy(() => import('./containers/indicaFornecedor/IndicaFornecedor'));
const AvaliacaoFornecedor = lazy(() => import('./containers/avaliacaoFornecedor/AvaliacaoFornecedor'));
const AvaliacaoAW = lazy(() => import('./containers/avaliacaoAW/AvaliacaoAW'));

function isLogged() {
	return LoginService.getToken('token') || false;
}

function router() {
	return (
		<Suspense fallback={<></>}>
			<Route path='/' exact render={() => <Redirect to='/status-homologacao' />} />
			<Route
				path='/login/:type?/:k?'
				render={() => (isLogged() ? <Redirect to='/status-homologacao' /> : <LoginFornecedor />)}
			/>
			<Route path='/home' exact render={() => (isLogged() ? <Home /> : <Redirect to='/login?redirect=home' />)} />
			<Route path='/indicacao' exact component={IndicaFornecedor} />
			<Route
				path='/status-homologacao'
				exact
				render={() =>
					isLogged() ? <StatusHomologacao /> : <Redirect to='/login?redirect=status-homologacao' />
				}
			/>
			<Route
				path='/avaliacoes/:status?'
				exact
				render={props =>
					isLogged() ? <AvaliacaoFornecedor {...props} /> : <Redirect to='/login?redirect=avaliacoes' />
				}
			/>
			<Route
				path='/avaliacao-aw'
				exact
				render={props =>
					isLogged() ? <AvaliacaoAW {...props} /> : <Redirect to='/login?redirect=avaliacao-aw' />
				}
			/>
		</Suspense>
	);
}

export default router;
